import React from 'react';

const Button = ({ text, onClick, icon, icons, className, btn_css, value,strongText ,disabled}) => {
  return (
    <button
      type="submit"
      className={className}
      onClick={onClick}
      disabled={disabled}
    >
      {<i className={icons }></i>}
      {" "}{text}{" "}
      {<i className={icon}></i>}
      {<span className={btn_css}>{value}</span>}
      {<strong>{strongText}</strong>}
    </button>
  );
};

export default Button;
